import { render, staticRenderFns } from "./pc-part-1.vue?vue&type=template&id=bbcc363c&scoped=true"
import script from "./pc-part-1.vue?vue&type=script&lang=js"
export * from "./pc-part-1.vue?vue&type=script&lang=js"
import style0 from "./pc-part-1.vue?vue&type=style&index=0&id=bbcc363c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcc363c",
  null
  
)

export default component.exports